"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Field = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var flexbox_1 = require("../flexbox");
var mini_icons_1 = require("../mini-icons");
var padding_1 = require("../padding");
var stack_1 = require("../stack");
var text_1 = require("../text");
var tooltip_1 = require("../tooltip");
function shouldShowError(error, touched) {
    if (typeof touched !== 'undefined') {
        return typeof error === 'string' && touched;
    }
    if (typeof error === 'string') {
        return true;
    }
    return false;
}
function Field(props) {
    var children = props.children, label = props.label, hint = props.hint, error = props.error, fieldId = props.fieldId, subText = props.subText, tooltip = props.tooltip, renderHelper = props.renderHelper, _a = props.hideEmptyLabel, hideEmptyLabel = _a === void 0 ? false : _a, style = props.style, touched = props.touched;
    var showError = shouldShowError(error, touched);
    return (react_1.default.createElement("div", { "data-testid": fieldId, style: style },
        react_1.default.createElement(stack_1.Stack, { gap: 8, direction: "vertical", key: label },
            (label || subText || tooltip || renderHelper || !hideEmptyLabel) && (react_1.default.createElement(flexbox_1.Flexbox, { justifyContent: "space-between" },
                react_1.default.createElement("label", { htmlFor: fieldId },
                    react_1.default.createElement(flexbox_1.Flexbox, { alignItems: "center" },
                        react_1.default.createElement(text_1.Text, { weight: 600, color: "dark", style: { minHeight: '21px' } }, label),
                        subText && (react_1.default.createElement(padding_1.Padding, { left: 4 },
                            react_1.default.createElement(text_1.Text, { weight: 300, color: "dark" }, subText))),
                        tooltip && (react_1.default.createElement(padding_1.Padding, { left: 4 },
                            react_1.default.createElement(tooltip_1.Tooltip, { text: tooltip },
                                react_1.default.createElement(mini_icons_1.MiniIconQuestionMark, null)))))),
                renderHelper)),
            children,
            showError ? (react_1.default.createElement(text_1.Text, { color: "error", size: "small", "data-testid": "field:error:".concat(fieldId) }, error)) : (hint && react_1.default.createElement(text_1.Text, { size: "small" }, hint)))));
}
exports.Field = Field;
//# sourceMappingURL=index.js.map